export class Credentials {
    email: string;
    password: string;
}
